import React from 'react'
import LoginContainer from '../@c_containers/login_container/login.container'

const LoginPage = function () {
  return <LoginContainer />
}

export default LoginPage
